import * as toastr from "toastr";
import { ICAMSKey, IAPIResult, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';
import { ModalPrompts, PredefinedModalEnum } from '../Utility/ModalPrompts';
import * as events from '../Bus/Bus';
import { ContactListConfig, ICAMSContact } from '../Contacts/ContactsModels';
// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Entity_MaintComment {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openCommentCreatePanel = (camsKey: ICAMSKey): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-modals2').load(window.G_SITEFOLDERNAME +'/Maint/IssueCommentCreateView', { maintCode: camsKey.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#maintCommentCreateModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#maintCommentCreateForm"));

            $('#maintCommentCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#maintCommentCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#maintCommentCreateModal .modal-content"));
                let formData = new FormData(<any>$('#maintCommentCreateForm')[0]);

                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Maint/CreateIssueComment',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated issue!');

                                // Pop the reponse modal
                                $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Maint/IssueCommentCreatedResponseView', { maintCode: camsKey.code }, function (response, status, xhr) {
                                    Utilities.GetModal('#maintCommentCreatedResponseModal', ModalAction.Create);
                                });
                            }
                            else {
                                toastr.error('Failed to update issue!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#maintCommentCreateModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("#maintCommentCreateModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#maintCommentCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#maintCommentCreateModal', ModalAction.Hide);
            });
        });

    }

    public openCommentEditPanel = (commentID: number, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-modals2').load(window.G_SITEFOLDERNAME +'/Maint/IssueCommentEditView', { ID: commentID }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#maintCommentEditModal', ModalAction.Create);

            $('#maintCommentEdit_contactSearch').on('click', function () {
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));

                function callback(contact: Array<ICAMSContact>) {
                    $('[name="Contact"]').val(contact[0].ContactRef);
                    $('[name="ListName"]').val(contact[0].ListName);
                }
            });

            // Get form validation
            Utilities.InitFormValidation($("#maintCommentEditForm"));

            $('#maintCommentEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#maintCommentEditForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#maintCommentEditModal .modal-content"));
                let formData = new FormData(<any>$('#maintCommentEditForm')[0]);

                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Maint/UpdateIssueComment',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated comment!');

                            }
                            else {
                                toastr.error('Failed to update comment!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#maintCommentEditModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("#maintCommentEditModal .modal-content"));
                            if (callback != null) callback(result.success);
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#maintCommentEditCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#maintCommentEditModal', ModalAction.Hide);
                if (callback != null) callback(false);
            });

            $('#maintCommentEditCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#maintCommentEditModal', ModalAction.Hide);
                if (callback != null) callback(false);
            });

            $('#maintCommentEditDeleteBtn').on('click', function (evt) {
                self.deleteEntity(commentID, function (success) {
                    if (success == true) {
                        Utilities.GetModal('#maintCommentEditModal', ModalAction.Hide);
                        callback(success);
                    }
                });
            });
        });

    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (commentID: Number, callback: Function): void => {
        const self = this;

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/Maint/DeleteComment', { commentID : commentID},
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            callback(true);
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            callback(false);
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                        callback(false);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }
}




